<template>
<div class="leadership__bio">
  <button 
    class="btn leadership__button"
    @click="toggleMoreText"
    :class="{ 'less': showMoreText }"
  >
    Biography
  </button>
  <div 
      class="leadership__content" 
      ref="overviewcontainer"
    >
      <div 
        class="leadership__text" 
        v-html="bio" 
        ref="overview"
        :class="{ active : showMoreText }"
      >
      </div>      
    </div>
</div>
</template>

<script>
export default {
  props: {
    bio: { type: String },
  },
  data() {
    return {
      showMoreText: true,
      originalHeight: null,
    };
  },
  mounted() {
    this.calculateOriginalHeight();
    this.toggleMoreText();
    // window.addEventListener('resize', this.calculateOriginalHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateOriginalHeight);
  },
  methods: {
    calculateOriginalHeight() {
      this.originalHeight = this.$refs.overview.clientHeight + 'px';
      this.$refs.overviewcontainer.style.height = this.originalHeight;
    },
    toggleMoreText() {
      this.$refs.overviewcontainer.style.height = this.showMoreText ? '1px' : this.originalHeight;
      this.showMoreText = !this.showMoreText;
    },
  },
};
</script>